import React, { useMemo } from 'react'

import { SxProps, useMediaQuery, useTheme } from '@mui/material'

import { CustomPeriodFilter, PeriodFilter } from 'types/GlobalWidget'

import { FilterPopoverProps } from 'components_new/molecules/FilterPopover'

import Desktop from './desktop'
import Mobile from './mobile'

interface PeriodSelectorBaseProps {
  showActive?: boolean
  size?: FilterPopoverProps['size']
  sx?: SxProps
}

interface PeriodSelectorWithResetProps extends PeriodSelectorBaseProps {
  allowReset?: true
  onSubmit: (periodFilter: PeriodFilter | CustomPeriodFilter | null) => void
  periodFilter: PeriodFilter | CustomPeriodFilter | null
}

interface PeriodSelectorWithoutResetProps extends PeriodSelectorBaseProps {
  allowReset: false
  onSubmit: (periodFilter: PeriodFilter | CustomPeriodFilter) => void
  periodFilter: PeriodFilter | CustomPeriodFilter
}

export type PeriodSelectorProps =
  | PeriodSelectorWithResetProps
  | PeriodSelectorWithoutResetProps

const PeriodSelector = (props: PeriodSelectorProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'), {
    noSsr: true
  })

  const memoizedComponent = useMemo(
    () => (isMobile ? <Mobile {...props} /> : <Desktop {...props} />),
    [isMobile, props.periodFilter, props.onSubmit]
  )

  return memoizedComponent
}

export default PeriodSelector
